/**
 * Wraps phrasing-only list item content in <p> for CMS HTML (reader-mode / semantics).
 * Skips items that already have a direct <p>, or block-level children (e.g. div).
 */

const PHRASING_TAGS = new Set([
  'A',
  'SPAN',
  'STRONG',
  'EM',
  'B',
  'I',
  'U',
  'SMALL',
  'ABBR',
  'CITE',
  'CODE',
  'Q',
  'S',
  'SUB',
  'SUP',
  'BR',
  'IMG',
  'MARK',
  'WBR',
  'BDI',
  'BDO',
  'DATA',
  'DFN',
  'KBD',
  'RP',
  'RT',
  'RUBY',
  'SAMP',
  'TIME',
  'VAR',
])

function hasDirectParagraphChild(li) {
  return Array.from(li.children).some(el => el.tagName === 'P')
}

function isPhrasingOnlyContent(container) {
  for (let i = 0; i < container.childNodes.length; i += 1) {
    const child = container.childNodes[i]
    if (child.nodeType === 1 && !PHRASING_TAGS.has(child.tagName)) {
      return false
    }
  }
  return true
}

function wrapOneListItem(li, doc) {
  if (hasDirectParagraphChild(li)) {
    return
  }

  const firstListChild = Array.from(li.children).find(el => el.tagName === 'UL' || el.tagName === 'OL')

  if (firstListChild) {
    const p = doc.createElement('p')
    while (li.firstChild && li.firstChild !== firstListChild) {
      p.appendChild(li.firstChild)
    }
    if (!p.firstChild) {
      return
    }
    if (isPhrasingOnlyContent(p)) {
      li.insertBefore(p, firstListChild)
    } else {
      while (p.firstChild) {
        li.insertBefore(p.firstChild, firstListChild)
      }
    }
    return
  }

  if (!isPhrasingOnlyContent(li)) {
    return
  }

  const p = doc.createElement('p')
  while (li.firstChild) {
    p.appendChild(li.firstChild)
  }
  li.appendChild(p)
}

export default function wrapListItemParagraphs(html) {
  if (typeof html !== 'string' || !html.trim()) {
    return html
  }
  if (typeof document === 'undefined') {
    return html
  }

  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(`<div id="wrap-li-p-root">${html}</div>`, 'text/html')
    const root = doc.getElementById('wrap-li-p-root')
    if (!root) {
      return html
    }

    root.querySelectorAll('li').forEach(li => wrapOneListItem(li, doc))

    return root.innerHTML
  } catch (e) {
    return html
  }
}
